import { provideConfig } from '@spartacus/core'
import { NgModule } from '@angular/core'
import { FsComponentConverter } from 'fs-spartacus-common'
import { CONTACT_BOX_FULL_CONVERTER_TOKEN, ContactBoxFullConverter } from './contact-box-full.component.converter'

@NgModule({
  providers: [
    provideConfig({
      featureModules: {
        contactBoxFullFeature: {
          module: () => import('./contact-box-full.module').then((m) => m.ContactBoxFullModule),
          cmsComponents: ['contact_box_full']
        },
      }
    }),
    {
      provide: CONTACT_BOX_FULL_CONVERTER_TOKEN,
      useExisting: ContactBoxFullConverter,
      multi: true
    },
    {
      provide: FsComponentConverter,
      useValue: {
        contact_box_full: CONTACT_BOX_FULL_CONVERTER_TOKEN
      },
      multi: true
    }
  ]
})
export class ContactBoxFullFeatureModule {}
